import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "List Kartu"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Kartu pada card desain")
  ])
], -1)
const _hoisted_3 = { class: "container mb-3" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-3" }
const _hoisted_6 = { class: "col-3" }
const _hoisted_7 = { class: "d-flex align-items-center position-relative" }
const _hoisted_8 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_9 = { class: "col-3" }
const _hoisted_10 = { class: "col-3 text-end" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-download",
  style: {"color":"#fff"}
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Download ")
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "card-body py-3" }
const _hoisted_15 = { class: "table-responsive" }
const _hoisted_16 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", null, "No"),
    /*#__PURE__*/_createElementVNode("th", null, "NIS"),
    /*#__PURE__*/_createElementVNode("th", null, "Nama"),
    /*#__PURE__*/_createElementVNode("th", null, "tags"),
    /*#__PURE__*/_createElementVNode("th", null, "Barcode"),
    /*#__PURE__*/_createElementVNode("th", null, "Action")
  ])
], -1)
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = ["disabled", "onClick"]
const _hoisted_22 = ["disabled", "onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-download",
  style: {"color":"#fff"}
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Download ")
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { key: 1 }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "7",
    class: "text-center"
  }, "Tidak Ada Data")
], -1)
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "row mt-3" }
const _hoisted_30 = { class: "col-2" }
const _hoisted_31 = ["value"]
const _hoisted_32 = { class: "col-4 align-self-center" }
const _hoisted_33 = { class: "col-6 text-end" }
const _hoisted_34 = { class: "pagination justify-content-end mb-0" }
const _hoisted_35 = { class: "row mt-4" }
const _hoisted_36 = { class: "col text-end" }
const _hoisted_37 = { class: "row mt-5 mb-5" }
const _hoisted_38 = {
  class: "modal fade",
  tabindex: "-1",
  "data-bs-backdrop": "static",
  id: "kt_modal_generate"
}
const _hoisted_39 = { class: "modal-dialog modal-dialog-centered modal-lg" }
const _hoisted_40 = { class: "modal-content rounded" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header py-2 border-0 justify-content-start" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-5" }, "Pilihan Kartu Bercode"),
    /*#__PURE__*/_createElementVNode("div", {
      class: "text-muted",
      style: {"font-size":"13px"}
    }, " Pilihan Kartu berbarcode ")
  ])
], -1)
const _hoisted_42 = { class: "modal-body" }
const _hoisted_43 = { class: "form-check form-check-inline" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "semuaKartu"
}, " Semua Kartu ", -1)
const _hoisted_45 = { class: "form-check form-check-inline" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "sebagianKartu"
}, " Sebagian Kartu ", -1)
const _hoisted_47 = {
  key: 0,
  class: "mb-3 mt-3"
}
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-3" }
const _hoisted_50 = { class: "col-3" }
const _hoisted_51 = { class: "d-flex align-items-center position-relative" }
const _hoisted_52 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_53 = { class: "col-3" }
const _hoisted_54 = {
  key: 1,
  class: "table align-middle gs-0 gy-4"
}
const _hoisted_55 = { class: "fw-bolder text-muted bg-light" }
const _hoisted_56 = { class: "text-center" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("th", null, "No", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("th", null, "NIS", -1)
const _hoisted_59 = /*#__PURE__*/_createElementVNode("th", null, "Nama", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("th", null, "tags", -1)
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { class: "text-center" }
const _hoisted_63 = ["value"]
const _hoisted_64 = { key: 0 }
const _hoisted_65 = { key: 1 }
const _hoisted_66 = { key: 1 }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "7",
    class: "text-center"
  }, "Tidak Ada Data")
], -1)
const _hoisted_68 = [
  _hoisted_67
]
const _hoisted_69 = {
  key: 2,
  class: "row mt-3"
}
const _hoisted_70 = { class: "col-2" }
const _hoisted_71 = ["value"]
const _hoisted_72 = { class: "col-4 align-self-center" }
const _hoisted_73 = { class: "col-6 text-end" }
const _hoisted_74 = { class: "pagination justify-content-end mb-0" }
const _hoisted_75 = { class: "modal-footer justify-content-end" }
const _hoisted_76 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_preview_barcode",
  ref: "previewModal"
}
const _hoisted_77 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_78 = { class: "modal-content rounded" }
const _hoisted_79 = { class: "modal-header py-2 border-0" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Preview Barcode", -1)
const _hoisted_81 = { class: "modal-body text-center" }
const _hoisted_82 = ["src"]
const _hoisted_83 = {
  key: 1,
  class: "text-muted"
}

export function render(_ctx: any,_cache: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_vue3_tags_input = _resolveComponent("vue3-tags-input")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Multiselect = _resolveComponent("Multiselect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.widgetClasses, "card"])
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_vue3_tags_input, {
              tags: _ctx.nis,
              placeholder: "Cari Nomor Identitas Lalu tekan Enter",
              onOnTagsChanged: _ctx.handleChangeNis,
              style: {"width":"100%"}
            }, null, 8, ["tags", "onOnTagsChanged"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, [
                _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control form-control-sm ps-15",
                placeholder: "Cari Nama",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                onKeyup: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePageSize()))
              }, null, 544), [
                [_vModelText, _ctx.name]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Multiselect, {
              class: "mx-1",
              modelValue: _ctx.tag,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tag) = $event)),
              placeholder: "Cari Tag",
              mode: "multiple",
              hideSelected: false,
              searchable: "",
              options: _ctx.tagList
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("button", {
              class: "btn btn-download btn-sm",
              style: {"background":"#a100ff","color":"#fff"},
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.downloadAllBarcode()))
            }, _hoisted_13)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("table", _hoisted_16, [
            _hoisted_17,
            (_ctx.listItems.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listItems, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                      _createElementVNode("td", null, _toDisplayString(item.nis), 1),
                      _createElementVNode("td", null, _toDisplayString(item.name), 1),
                      _createElementVNode("td", null, [
                        (Array.isArray(item.tags))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tags, (tag, i) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: i,
                                  class: "badge bg-success me-1"
                                }, _toDisplayString(tag), 1))
                              }), 128))
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(item.tags), 1))
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          disabled: !item.barcode_url,
                          class: "btn btn-primary btn-sm",
                          onClick: ($event: any) => (_ctx.previewBarcode(item))
                        }, " Preview ", 8, _hoisted_21)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          disabled: !item.barcode_url,
                          class: "btn btn-download btn-sm",
                          style: {"background":"#a100ff","color":"#fff"},
                          onClick: ($event: any) => (_ctx.downloadBarcode(item))
                        }, _hoisted_25, 8, _hoisted_22)
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_26, _hoisted_28))
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.paging.size) = $event)),
              onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.changePageSize && _ctx.changePageSize(...args))),
              class: "form-select form-select-sm"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paging.perPageOptions, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: item,
                  value: item
                }, _toDisplayString(item), 9, _hoisted_31))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.paging.size]
            ])
          ]),
          _createElementVNode("div", _hoisted_32, " Showing " + _toDisplayString(_ctx.from + 1) + " to " + _toDisplayString(_ctx.to) + " of " + _toDisplayString(_ctx.paging.totalElements) + " entries ", 1),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("ul", _hoisted_34, [
              _createElementVNode("li", {
                class: _normalizeClass(["page-item previous", { disabled: _ctx.paging.page + 1 === 1 }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)))
                }, "Previous")
              ], 2),
              _createElementVNode("li", {
                class: _normalizeClass(["page-item next", { disabled: _ctx.paging.page + 1 === _ctx.paging.totalPages }])
              }, [
                _createElementVNode("a", {
                  class: "page-link",
                  style: {"cursor":"pointer"},
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)))
                }, "Next")
              ], 2)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("button", {
              class: "btn btn-danger me-2",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onCancel && _ctx.onCancel(...args)))
            }, "Batal"),
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.getCardData(_ctx.pagingModal.size, _ctx.pagingModal.page)))
            }, " Generate ")
          ])
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "radio",
                  id: "semuaKartu",
                  value: "semua",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.generateOption) = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.generateOption]
                ]),
                _hoisted_44
              ]),
              _createElementVNode("div", _hoisted_45, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "radio",
                  id: "sebagianKartu",
                  value: "sebagian",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.generateOption) = $event))
                }, null, 512), [
                  [_vModelRadio, _ctx.generateOption]
                ]),
                _hoisted_46
              ]),
              (_ctx.generateOption === 'sebagian')
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _createVNode(_component_vue3_tags_input, {
                          tags: _ctx.filterModal.nis,
                          placeholder: "Cari Nomor Identitas Lalu tekan Enter",
                          onOnTagsChanged: _ctx.handleChangeNisModal,
                          style: {"width":"100%"}
                        }, null, 8, ["tags", "onOnTagsChanged"])
                      ]),
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("div", _hoisted_51, [
                          _createElementVNode("span", _hoisted_52, [
                            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            class: "form-control form-control-sm ps-15",
                            placeholder: "Cari Nama",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filterModal.name) = $event)),
                            onKeyup: _cache[13] || (_cache[13] = ($event: any) => (_ctx.changePageSizeModal()))
                          }, null, 544), [
                            [_vModelText, _ctx.filterModal.name]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_53, [
                        _createVNode(_component_Multiselect, {
                          class: "mx-1",
                          modelValue: _ctx.filterModal.tag,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.filterModal.tag) = $event)),
                          placeholder: "Cari Tag",
                          mode: "multiple",
                          hideSelected: false,
                          searchable: "",
                          options: _ctx.tagList
                        }, null, 8, ["modelValue", "options"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.generateOption === 'sebagian')
                ? (_openBlock(), _createElementBlock("table", _hoisted_54, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", _hoisted_55, [
                        _createElementVNode("th", _hoisted_56, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.allSelectedGenerate) = $event)),
                            onChange: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAllGenerate && _ctx.toggleSelectAllGenerate(...args)))
                          }, null, 544), [
                            [_vModelCheckbox, _ctx.allSelectedGenerate]
                          ])
                        ]),
                        _hoisted_57,
                        _hoisted_58,
                        _hoisted_59,
                        _hoisted_60
                      ])
                    ]),
                    (_ctx.cardData.length)
                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_61, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardData, (item, index) => {
                            return (_openBlock(), _createElementBlock("tr", { key: index }, [
                              _createElementVNode("td", _hoisted_62, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.selectedItemsGenerate) = $event)),
                                  value: item
                                }, null, 8, _hoisted_63), [
                                  [_vModelCheckbox, _ctx.selectedItemsGenerate]
                                ])
                              ]),
                              _createElementVNode("td", null, _toDisplayString(_ctx.fromModal + index + 1), 1),
                              _createElementVNode("td", null, _toDisplayString(item.nis), 1),
                              _createElementVNode("td", null, _toDisplayString(item.name), 1),
                              _createElementVNode("td", null, [
                                (Array.isArray(item.tags))
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_64, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.tags, (tag, i) => {
                                        return (_openBlock(), _createElementBlock("span", {
                                          key: i,
                                          class: "badge bg-success me-1"
                                        }, _toDisplayString(tag), 1))
                                      }), 128))
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_65, _toDisplayString(item.tags), 1))
                              ])
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("tbody", _hoisted_66, _hoisted_68))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.generateOption === 'sebagian')
                ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.pagingModal.size) = $event)),
                        onChange: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.changePageSizeModal && _ctx.changePageSizeModal(...args))),
                        class: "form-select form-select-sm"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pagingModal.perPageOptions, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: item,
                            value: item
                          }, _toDisplayString(item), 9, _hoisted_71))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, _ctx.pagingModal.size]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_72, " Showing " + _toDisplayString(_ctx.fromModal + 1) + " to " + _toDisplayString(_ctx.toModal) + " of " + _toDisplayString(_ctx.pagingModal.totalElements) + " entries ", 1),
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("ul", _hoisted_74, [
                        _createElementVNode("li", {
                          class: _normalizeClass(["page-item previous", { disabled: _ctx.pagingModal.page + 1 === 1 }])
                        }, [
                          _createElementVNode("a", {
                            class: "page-link",
                            style: {"cursor":"pointer"},
                            onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.prevPageModal && _ctx.prevPageModal(...args)))
                          }, "Previous")
                        ], 2),
                        _createElementVNode("li", {
                          class: _normalizeClass(["page-item next", {
                      disabled: _ctx.pagingModal.page + 1 === _ctx.pagingModal.totalPages,
                    }])
                        }, [
                          _createElementVNode("a", {
                            class: "page-link",
                            style: {"cursor":"pointer"},
                            onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.nextPageModal && _ctx.nextPageModal(...args)))
                          }, "Next")
                        ], 2)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_75, [
              _createElementVNode("button", {
                class: "btn btn-danger me-2",
                onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.onCancelGenerate && _ctx.onCancelGenerate(...args))),
                "data-bs-dismiss": "modal"
              }, " Batal "),
              _createElementVNode("button", {
                class: "btn",
                style: { background: '#6C7CFF', color: '#fff' },
                onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.handleGenerate && _ctx.handleGenerate(...args)))
              }, " Generate ")
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_76, [
      _createElementVNode("div", _hoisted_77, [
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("div", _hoisted_79, [
            _hoisted_80,
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.closePreviewModal && _ctx.closePreviewModal(...args)))
            })
          ]),
          _createElementVNode("div", _hoisted_81, [
            (_ctx.previewImageUrl)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.previewImageUrl,
                  alt: "Barcode Preview",
                  style: {"max-width":"100%","max-height":"400px"}
                }, null, 8, _hoisted_82))
              : (_openBlock(), _createElementBlock("div", _hoisted_83, "Tidak ada gambar barcode")),
            _createElementVNode("p", null, _toDisplayString(this.barcode), 1)
          ])
        ])
      ])
    ], 512)
  ], 64))
}